import {API} from "@/middlewares/api";
import {createAsyncThunk} from "@reduxjs/toolkit";

export const signIn = createAsyncThunk("auth/signIn", async (data, thunkAPI) => {
  try {
    const response = await API("login", {
      method: "POST",
      body: data,
    });

    if ("error" in response) {
      return thunkAPI.rejectWithValue(response);
    }

    return thunkAPI.fulfillWithValue(response);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const magicLinkSignIn = createAsyncThunk("auth/magicLinkSignIn", async ({code, ip, siteId}, thunkAPI) => {
  try {
    const response = await API(`login/${code}`, {
      method: "POST",
      body: {
        ip,
        siteId,
      },
    });

    return thunkAPI.fulfillWithValue(response);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const generateMagicLinkSignIn = createAsyncThunk(
  "auth/generateMagicLinkSignIn",
  async ({customerEmailAddress}, thunkAPI) => {
    try {
      const response = await API("generate-magic-link", {
        method: "POST",
        body: {
          customerEmailAddress,
        },
      });

      return thunkAPI.fulfillWithValue(response);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const activateKit = createAsyncThunk("auth/activateKit", async (activationCode, thunkAPI) => {
  try {
    const response = await API(`activation/check-activation-token/${activationCode}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const updatePassword = createAsyncThunk(
  "auth/updatePassword",
  async ({currentPassword, newPassword2}, thunkAPI) => {
    try {
      const response = await API("secure/update-password", {
        method: "POST",
        body: {
          currentPassword,
          newPassword2,
        },
      });

      return thunkAPI.fulfillWithValue(response);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const createNewAccount = createAsyncThunk("auth/createNewAccount", async (payload, thunkAPI) => {
  try {
    const response = await API("signup", {
      method: "POST",
      body: payload,
    });

    return thunkAPI.fulfillWithValue(response);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const checkResetToken = createAsyncThunk("auth/checkResetToken", async (token, thunkAPI) => {
  try {
    const response = await API(`check-reset-token/${token}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});

export const resetForgottenPassword = createAsyncThunk("auth/resetForgottenPassword", async (payload, thunkAPI) => {
  try {
    const response = await API("update-password", {body: payload, method: "POST"});

    return thunkAPI.fulfillWithValue(response);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});
